
import {Component} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {ApiServiceService} from '../api-service.service';

@Component({
    selector: 'app-rejectloan',
    templateUrl: './rejectloan.component.html',
    styleUrls: ['./rejectloan.component.css'],
    providers: [ApiServiceService]
})
export class RejectloanComponent {
    public rejectreason: any;

    constructor(public dialogRef: MatDialogRef<RejectloanComponent>) {
    }
}